import React from 'react';

const Subhead = ({ text, classNames }) => {
  return <p className={`mt-[15px] ${classNames}`}>{text}</p>;
};

export default Subhead;
